(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["acb-giveaway-popup"] && !Shopify.designMode) return;
  try {
    (() => {
    const popup = document.getElementById('AcbGiveawayPopup');
    if (!popup || popup.dataset.ready === 'true') return;
    popup.dataset.ready = 'true';

    if (new URLSearchParams(window.location.search).get('acb_mobile_preview') === '1') {
      popup.classList.add('acb-giveaway--mobile-preview');
    }

    const endpoint = 'https://hook.us1.make.com/li5w87yw9vej3u2nxmcey4itsts94a7h';
    const sampleEndpoint = 'https://hook.us1.make.com/w23fwh7q01dno1kuhl1gxnkuw10cj71t';
    const form = popup.querySelector('[data-acb-email-form]');
    const emailInput = popup.querySelector('#AcbGiveawayEmail');
    const error = popup.querySelector('[data-acb-error]');
    const thanksMessage = popup.querySelector('[data-acb-thanks-message]');
    const mailingForm = popup.querySelector('[data-acb-mailing-form]');
    const missingProfile = popup.querySelector('[data-acb-missing-profile]');
    const steps = popup.querySelectorAll('[data-acb-step]');
    const sampleTab = document.querySelector('[data-acb-sample-tab]');
    const sampleTabTrigger = sampleTab.querySelector('[data-acb-sample-tab-trigger]');
    const sampleTabClose = sampleTab.querySelector('[data-acb-sample-tab-close]');
    const introEyebrow = popup.querySelector('[data-acb-step="email"] .acb-giveaway__eyebrow');
    const introTitle = popup.querySelector('[data-acb-step="email"] .acb-giveaway__title');
    const introLifetime = popup.querySelector('.acb-giveaway__lifetime');
    const introSupport = popup.querySelector('[data-acb-step="email"] .acb-giveaway__support');
    const introLegal = popup.querySelector('[data-acb-step="email"] .acb-giveaway__legal');
    let capturedEmail = '';
    let capturedProfile = {};
    let selectedColor = 'Angel’s Favorite Colors';
    let fabricInterestMode = false;

    const showStep = (name) => {
      steps.forEach((step) => {
        step.hidden = step.dataset.acbStep !== name;
      });
    };

    const sampleTabDismissedRecently = () => {
      const dismissedAt = Number(localStorage.getItem('acbSampleTabDismissedAt') || 0);
      return Date.now() - dismissedAt < 24 * 60 * 60 * 1000;
    };

    const closePopup = () => {
      localStorage.setItem('acbGiveawayClosedAt', String(Date.now()));
      popup.close();
      sampleTab.hidden = fabricInterestMode || sampleTabDismissedRecently();
    };

    const post = async (payload, destination = endpoint) => {
      const response = await fetch(destination, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
        body: new URLSearchParams(payload)
      });
      if (!response.ok) throw new Error('Signup request failed');
    };

    const prepareMissingProfileFields = () => {
      popup.querySelector('#AcbSampleFirstName').value = String(capturedProfile.first_name || '').trim();
      let hasMissingField = false;
      ['phone', 'instagram'].forEach((fieldName) => {
        const wrapper = missingProfile.querySelector(`[data-acb-profile-field="${fieldName}"]`);
        const input = wrapper.querySelector('input');
        const isMissing = !String(capturedProfile[fieldName] || '').trim();
        wrapper.hidden = !isMissing;
        input.required = isMissing;
        hasMissingField = hasMissingField || isMissing;
      });
      missingProfile.hidden = !hasMissingField;
    };

    popup.querySelectorAll('[data-acb-close]').forEach((button) => {
      button.addEventListener('click', closePopup);
    });

    popup.addEventListener('cancel', (event) => {
      event.preventDefault();
      closePopup();
    });

    sampleTabTrigger.addEventListener('click', () => {
      fabricInterestMode = true;
      capturedProfile = {};
      const sampleEmailField = popup.querySelector('[data-acb-sample-email-field]');
      const sampleEmailInput = popup.querySelector('#AcbSampleEmail');
      sampleEmailField.hidden = false;
      sampleEmailInput.required = true;
      sampleEmailInput.value = capturedEmail || emailInput.value.trim().toLowerCase();
      prepareMissingProfileFields();
      showStep('mailing');
      sampleTab.hidden = true;
      if (!popup.open && typeof popup.showModal === 'function') popup.showModal();
      window.requestAnimationFrame(() => sampleEmailInput.focus());
    });

    sampleTabClose.addEventListener('click', () => {
      localStorage.setItem('acbSampleTabDismissedAt', String(Date.now()));
      sampleTab.hidden = true;
    });

    const countryInput = popup.querySelector('#AcbCountry');
    const countryNote = popup.querySelector('[data-acb-country-note]');
    ['click', 'focus'].forEach((eventName) => {
      countryInput.addEventListener(eventName, () => {
        countryNote.hidden = false;
      });
    });

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      error.hidden = true;
      if (!emailInput.checkValidity()) {
        error.hidden = false;
        emailInput.focus();
        return;
      }

      const submitButton = form.querySelector('button[type="submit"]');
      capturedEmail = emailInput.value.trim().toLowerCase();
      submitButton.disabled = true;
      submitButton.textContent = fabricInterestMode ? 'CONTINUING…' : 'ENTERING…';

      try {
        if (fabricInterestMode) {
          capturedProfile = {};
          prepareMissingProfileFields();
          showStep('mailing');
        } else {
          await post({
            action: 'email_signup',
            email: capturedEmail,
            source: 'acb_2027_monthly_giveaway',
            page_url: window.location.href,
            submitted_at: new Date().toISOString()
          });
          localStorage.setItem('acbGiveawayEnteredAt', String(Date.now()));
          showStep('timing');
        }
      } catch (requestError) {
        error.textContent = 'Something went wrong. Please try again.';
        error.hidden = false;
      } finally {
        submitButton.disabled = false;
        submitButton.textContent = fabricInterestMode ? 'CONTINUE' : 'ENTER GIVEAWAY';
      }
    });

    popup.querySelectorAll('[data-acb-timing]').forEach((button) => {
      button.addEventListener('click', async () => {
        popup.querySelectorAll('[data-acb-timing]').forEach((option) => { option.disabled = true; });
        try {
          await post({
            action: 'competition_timing',
            email: capturedEmail,
            competition_timing: button.dataset.acbTiming,
            source: 'acb_2027_monthly_giveaway',
            submitted_at: new Date().toISOString()
          });
        } finally {
          showStep('division');
        }
      });
    });

    popup.querySelectorAll('[data-acb-division]').forEach((button) => {
      button.addEventListener('click', async () => {
        try {
          await post({ action: 'competition_division', email: capturedEmail, competition_division: button.dataset.acbDivision, source: 'acb_2027_monthly_giveaway', submitted_at: new Date().toISOString() });
        } finally {
          showStep('contact');
        }
      });
    });

    popup.querySelector('[data-acb-contact-form]').addEventListener('submit', async (event) => {
      event.preventDefault();
      const data = new FormData(event.currentTarget);
      capturedProfile = {
        first_name: data.get('first_name'),
        phone: data.get('phone'),
        instagram: data.get('instagram'),
        sms_consent: data.get('sms_consent') === 'yes' ? 'true' : 'false',
        sms_consent_timestamp: data.get('sms_consent') === 'yes' ? new Date().toISOString() : '',
        attentive_phone: data.get('sms_consent') === 'yes' ? data.get('phone') : ''
      };
      try {
        await post({ action: 'contact_details', email: capturedEmail, ...capturedProfile, source: 'acb_2027_monthly_giveaway', submitted_at: new Date().toISOString() });
      } finally {
        showStep('samples');
      }
    });

    popup.querySelectorAll('[data-acb-samples]').forEach((button) => {
      button.addEventListener('click', async () => {
        const sampleStatus = button.dataset.acbSamples;
        try {
          await post({ action: 'fabric_samples', email: capturedEmail, fabric_sample_status: sampleStatus, source: 'acb_2027_monthly_giveaway', submitted_at: new Date().toISOString() });
        } finally {
          if (sampleStatus === 'needs_samples') prepareMissingProfileFields();
          showStep(sampleStatus === 'needs_samples' ? 'mailing' : 'thanks');
        }
      });
    });

    popup.querySelectorAll('[data-acb-color]').forEach((button) => {
      button.addEventListener('click', () => {
        selectedColor = button.dataset.acbColor;
        popup.querySelectorAll('[data-acb-color]').forEach((option) => {
          option.setAttribute('aria-checked', option === button ? 'true' : 'false');
        });
      });
    });

    mailingForm.addEventListener('submit', async (event) => {
      event.preventDefault();
      const data = new FormData(event.currentTarget);
      const sampleEmail = String(data.get('sample_email') || '').trim().toLowerCase();
      if (sampleEmail) capturedEmail = sampleEmail;
      capturedProfile = {
        first_name: String(data.get('sample_first_name') || '').trim(),
        phone: String(capturedProfile.phone || data.get('sample_phone') || '').trim(),
        instagram: String(capturedProfile.instagram || data.get('sample_instagram') || '').trim(),
        sms_consent: capturedProfile.sms_consent === 'true' || data.get('sample_sms_consent') === 'yes' ? 'true' : 'false',
        sms_consent_timestamp: capturedProfile.sms_consent === 'true'
          ? capturedProfile.sms_consent_timestamp
          : (data.get('sample_sms_consent') === 'yes' ? new Date().toISOString() : ''),
        attentive_phone: capturedProfile.sms_consent === 'true' || data.get('sample_sms_consent') === 'yes'
          ? String(capturedProfile.phone || data.get('sample_phone') || '').trim()
          : ''
      };
      try {
        await post({ action: 'contact_details', email: capturedEmail, ...capturedProfile, source: 'acb_2027_monthly_giveaway', submitted_at: new Date().toISOString() });
        await post({ email: capturedEmail, ...capturedProfile, last_name: data.get('last_name'), address1: data.get('address1'), address2: data.get('address2'), city: data.get('city'), state: data.get('state'), postal_code: data.get('postal_code'), country: data.get('country'), fabric_colors: selectedColor, source: 'acb_2027_monthly_giveaway' }, sampleEndpoint);
        thanksMessage.textContent = 'We’ll have those fabric samples in the mail ASAP.';
      } finally {
        showStep('thanks');
      }
    });

    popup.querySelectorAll('[data-acb-next]').forEach((button) => {
      button.addEventListener('click', () => showStep(button.dataset.acbNext));
    });

    const previewParams = new URLSearchParams(window.location.search);
    const forcePreview = previewParams.get('acb_popup_preview') === '1';
    const forceSampleTabPreview = previewParams.get('acb_sample_tab_preview') === '1';
    const previewStep = previewParams.get('acb_popup_step');
    const closedAt = Number(localStorage.getItem('acbGiveawayClosedAt') || 0);
    const closedRecently = Date.now() - closedAt < 24 * 60 * 60 * 1000;

    if (forceSampleTabPreview) {
      sampleTab.hidden = false;
    } else if (forcePreview || !closedRecently) {
      if (forcePreview && previewStep) showStep(previewStep);
      window.setTimeout(() => {
        if (typeof popup.showModal === 'function') {
          popup.showModal();
          if (!forcePreview) localStorage.setItem('acbGiveawayShownAt', String(Date.now()));
        }
      }, forcePreview ? 100 : 7000);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
